import BaseModel from './BaseModel'
// import handleAxiosError from '../utils/handleAxiosError'
import Facility from './Facility'
import SpotHeroFlexDiscount from './SpotHeroFlexDiscount'

export class ChannelFacility extends BaseModel {

  static entity = 'channel_facilities'
  static primaryKey = 'ID'

  declare ID: number
  declare channel: string
  declare facilityID: number
  declare externalFacilityID: string
  declare exChannelData: any
  declare facility: null | Facility
  declare spotheroFlexDiscounts: SpotHeroFlexDiscount[]

  static fields() {

    return {

      // fields
      ID: this.number(null).nullable(),
      channel: this.string(''),
      facilityID: this.number(null),
      externalFacilityID: this.string(''), // this corresponds to the ex_channel_id column in the database
      exChannelData: this.attr(null).nullable(),

      // relationships
      facility: this.belongsTo(Facility, 'facilityID'),
      spotheroFlexDiscounts: this.hasMany(SpotHeroFlexDiscount, 'channelFacilityID'),

    }

  }

  static fetchByLocationID(locationID: number): Promise<FetchChannelFacilityByLocationIdResponse> {

    return this.api()
      .get('/locations/' + locationID + '/channel_facilities', {
        dataKey: 'channelFacilities',
      })
      .then((result): FetchChannelFacilityByLocationIdResponse => result.response.data)
      // .catch(handleAxiosError)

  }

}

export interface FetchChannelFacilityByLocationIdResponse {
  channelFacilities: {
    ID: number
    channel: string
    facilityID: number
    externalFacilityID: string
  }[]
}
